
  import { Component, Vue } from "vue-property-decorator";
  import RouteNames from "@/entities/RouteNames";
  import RouteParams from "@/entities/RouteParams";
import UiButton from "@/components/button/ui-button.vue";
@Component({
    components: {
        UiButton
    },
})
  export default class InvitationPlaceholder extends Vue {
    get pricingLinkName(): RouteParams<{}> {
      return {
        name: RouteNames.PRICING,
      };
    }
  }
